import { Outlet } from 'react-router-dom';

import Header from 'src/components/layout/Header';

const PrivateLayout = () => {
  return (
    <div className="ra">
      <Header />
      <div className="ra-data">
        <div className="ra-data-inner">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;
